import { render, staticRenderFns } from "./reactive.vue?vue&type=template&id=545e8222&"
import script from "./reactive.vue?vue&type=script&lang=js&"
export * from "./reactive.vue?vue&type=script&lang=js&"
import style0 from "./reactive.vue?vue&type=style&index=0&lang=scss&scpoed=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports